import React, { useContext } from 'react';
import { Route } from 'react-router-dom';

import { AccountDataContext, LoginTypeContext } from 'modules/context';
import { useLoginToken } from 'modules/hooks';
import { CPD } from 'pages';

import { ProtectedRoutePropsType } from './types';
import { LoginTypeEnum } from 'modules/utils/types';

export const ProtectedRouteCpd: React.FunctionComponent<ProtectedRoutePropsType> =
  ({ path }) => {
    const { loginTypeContext } = useContext(LoginTypeContext);
    const { isLoggedIn } = useLoginToken();
    const { accountDataContext } = useContext(AccountDataContext);

    return (
      <Route path={path}>
        {loginTypeContext === LoginTypeEnum.INDIVIDUAL &&
          accountDataContext &&
          isLoggedIn() && <CPD />}
      </Route>
    );
  };
